import AnimMediaControl from './anim-media-control';
import { MediaRegion, type IMediaManager, type VideoType } from '@src/slide/application/service/media-manager/media-manager.interface';
import { IMediaParams } from '@src/slide/application/service/media-manager/params.interface';
import { VIDEO_STATE } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';

export default class EditorAnimVideoControl extends AnimMediaControl {
    public static instance: EditorAnimVideoControl;
    public static getInstance(mediaManager: IMediaManager): EditorAnimVideoControl {
        if (!this.instance) {
            this.instance = new EditorAnimVideoControl(mediaManager);
        }
        return this.instance;
    }

    public completeMediaControl(mediaParams: IMediaParams): void | undefined {
        this.mediaManager.pauseVideoByRegion(mediaParams.elementModel.key, MediaRegion.EDITOR);
    }

    public isPlaying(): boolean {
        const video = this.getMediaInstance(this.elementModel.key) as any;
        return video?.state === VIDEO_STATE.PLAYING;
    }

    // media开始播放
    protected playHandler(): void {
        const { mediaManager } = this;
        if (!mediaManager) return;
        mediaManager.playVideoByRegion(this.elementModel.key, MediaRegion.EDITOR);
    }

    // 预览态下tooglePause的行为: 始终从头播放
    protected togglePauseHandler(): void {
        this.playHandler();
    }

    // media结束播放
    protected stopHandler(): void {
        const { mediaManager } = this;
        if (!mediaManager) return;
        mediaManager.pauseVideoByRegion(this.elementModel.key, MediaRegion.EDITOR);
    }

    /**
     * 获取 Video实例
     * @returns super player实例
     */
    protected getMediaInstance(elementModelKey: string): VideoType | null {
        return this.mediaManager?.getVideoInstanceByRegion(elementModelKey, MediaRegion.EDITOR);
    }
}
